import React, { useState, useEffect, useContext } from "react";
import { Select, Table, Button } from "antd";

import { Context } from "../../../context";
import DataModal from "./model";
import "./index.css";

const timeframeOptions = [
    { id: 1, label: "Last 60 Minutes", value: "60:min" },
    { id: 2, label: "Last 6 Hours", value: "6:hours" },
    { id: 3, label: "Last 24 Hours", value: "24:hours" },
    { id: 4, label: "Last 7 Days", value: "7:days" },
    { id: 5, label: "Last 30 Days", value: "30:days" },
];

const columns = [
    { title: "Video Title", dataIndex: "video_title", key: "video_title" },
    { title: "Watch Time", dataIndex: "watch_time", key: "watch_time" },
    { title: "OS", dataIndex: "viewer_os_family", key: "viewer_os_family" },
    { title: "Country", dataIndex: "country_code", key: "country_code" },
];

const Views = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 25, total: 0 });
    const { token, apiUrl } = useContext(Context);
    const [error, setError] = useState(false);
    const [customData, setCustomData] = useState([]); // showing refferals data on filter
    const [customData2, setCustomData2] = useState([]); // showing users data on filter
    const [granularity, setGranularity] = useState("24:hours");
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedCustom1, setSelectedCustom1] = useState([]); // selected reffers
    const [selectedCustom2, setSelectedCustom2] = useState([]); // selected users

    const calculateWatchTime = (watchTime) => {
        const totalWatchTimeInSeconds = watchTime / 1000; 
        const totalWatchTimeInMinutes = totalWatchTimeInSeconds / 60; 
        const totalWatchTimeInHours = totalWatchTimeInMinutes / 60;

        if (totalWatchTimeInSeconds < 60) {
            return `${totalWatchTimeInSeconds.toFixed(0)} sec`; 
        } else if (totalWatchTimeInMinutes < 60) {
            return `${totalWatchTimeInMinutes.toFixed(2)} min`;
        } else {
            return `${totalWatchTimeInHours.toFixed(2)} hrs`;
        }
    }
    
    const handleTableChange = (pagination) => {
        fetchData(pagination.current);
    };

    useEffect(()=> {
        fetchData(pagination.current);
    },[])

    const fetchData = async (page) => {
        setLoading(true);
        try {
            const url = `${apiUrl}/metrics/views?page=${page}&timeframe=${granularity}&${selectedCustom1?.length ? `custom_1=${selectedCustom1.join(",")}` : ""}${selectedCustom2?.length ? `&custom_2=${selectedCustom2.join(",")}` : ""}`;
            const response = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
            const result = await response.json();
            setData(
                (result?.data || []).map(item => ({
                  ...item,
                  watch_time: calculateWatchTime(item.watch_time), 
                }))
              );
              
            setPagination((prev) => ({ ...prev, current: page, total: result?.total_row_count || 0 }));
        } catch (error) {
            setError(true);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
       
        const fetchDimensions = async () => {
            try {
                const custom1Response = await fetch(`${apiUrl}/metrics/custom-dimension?timeframe=${granularity}&dimension=custom_1&${selectedCustom2?.length ? `&custom_2=${selectedCustom2.join(",")}` : ""}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                const custom1Data = await custom1Response.json();
             
                setCustomData(custom1Data?.data);

                const custom2Response = await fetch(`${apiUrl}/metrics/custom-dimension?timeframe=${granularity}&dimension=custom_2&${selectedCustom1?.length ? `custom_1=${selectedCustom1.join(",")}` : ""}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                const custom2Data = await custom2Response.json();
                setCustomData2(custom2Data?.data);
            } catch (error) {
                setError(true);
            }
        };
        fetchDimensions();
        fetchData(pagination.current);
    }, [granularity, selectedCustom1, selectedCustom2]);

    const handleGranularityChange = (value) => {
        setGranularity(value);
        setPagination({ current: 1, pageSize: 25, total: 0 })
    }

    const handleFilterClick = () => setIsModalVisible(true);

    const handleCloseModal = () => {
        setIsModalVisible(false);
    };

    const handleApplyFilter = (selectedData) => {
        setSelectedCustom1(selectedData.users)
        setSelectedCustom2(selectedData.referral)
        setPagination({ current: 1, pageSize: 25, total: 0 })
    };

    return (
        <div className="views-main-container">
            <div style={{ display: "flex", justifyContent: "space-between", padding: "20px" }}>
                <h1 className="views-heading">Views</h1>
                <Button type="primary" onClick={handleFilterClick}>
                    Filter
                </Button>
                <Select
                    value={granularity}
                    onChange={handleGranularityChange}
                    style={{ width: 150 }}
                    className="time-selector"
                >
                    {timeframeOptions.map((each) => (
                        <Select.Option key={each.value} value={each.value}>
                            {each.label}
                        </Select.Option>
                    ))}
                </Select>
            </div>
            <Table
                columns={columns}
                dataSource={data}
                rowKey={(record) => record.id}
                pagination={{ ...pagination, showSizeChanger: false }}
                loading={loading}
                onChange={handleTableChange}
                locale={{
                    emptyText: error || data.length === 0 ? "No data found" : "No data available",
                }}
            />
            <div>
                <DataModal
                    isVisible={isModalVisible}
                    onClose={handleCloseModal}
                    custom1Data={customData}
                    custom2Data={customData2}
                    handleApplyFilter={handleApplyFilter}
                />
            </div>
        </div>
    );
};

export default Views;
